import React, { Component } from 'react';
import Logo from './Logo';
import Nav from './Nav';

class Header extends Component {
  render() {
    return (
      <div>
        <header id="header" className="alt">
          <Logo />
          <Nav />
        </header>
      </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js